<template>
  <div>
    <BaseError :httpCode="httpCode" :message="message" :toRoute="toRoute" />
  </div>
</template>

<script>
import BaseError from "./BaseError";

export default {
  name: "Http404",
  components: {
    BaseError,
  },
  data() {
    return {
      httpCode: 404,
      message: this.$t("errores.textos.404"),
      toRoute: {
        name: "dashboard",
        params: { tab: "claim-debt" },
        text: this.$t("errores.label.404"),
      },
    };
  },
};
</script>